// extracted by mini-css-extract-plugin
module.exports = {"pageArrowButton":"styles_pageArrowButton__g4Cqy","rightBorder":"styles_rightBorder__xgKjg","leftBorder":"styles_leftBorder___NUXs"};